const citiesKeys = {
  module: ['cities'] as const,
  list: () => [...citiesKeys.module, 'list'] as const,
  listWithFilters: (filters: any) => [...citiesKeys.list(), filters] as const,
  details: (id: string) => [...citiesKeys.module, 'details', id] as const,
  distances: (id: string) => [...citiesKeys.module, 'distances', id] as const,
  accessControls: (id: string) =>
    [...citiesKeys.module, 'access-controls', id] as const,
  neighborhoods: (id: string) =>
    [...citiesKeys.module, 'neighborhoods', id] as const,
  billingRecorency: (id: string) =>
    [...citiesKeys.module, 'billingRecorency', id] as const,
  deliveryMen: (cityId: string) =>
    [...citiesKeys.module, 'deliveryMen', cityId] as const,
};

export default citiesKeys;
